module.exports = __webpack_public_path__ + "img/35.ab1e9fc9.jpg";